const DND_TYPES = {
  QUESTION: "question",
  PALETTE_QUESTION: "palette-question",
  PAGE_ITEM: "page-item"
};

export default DND_TYPES;
